import {Component, OnInit} from '@angular/core';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FileUploadService} from '../../admin-services/file-upload.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, NgxIntlTelInputModule]
})
export class FileUploadComponent implements OnInit {

  // @TODO : VOIR QUOI FAIRE DU COMPOSANT




  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';
  preview = '';

  imageInfos?: Observable<any>;
  // Permet de savoir quel type d'upload l'utilisateur souhaite
  editCoverType:string = null;

  constructor(
    private uploadService: FileUploadService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.imageInfos = this.uploadService.getFiles();
  }


  public selectEditCoverType(type:string) :void {
    this.editCoverType = type;
    if (!type) {
      this.preview = null;
    }
  }

  //
  public selectFile(event: any): void {
    this.message = '';
    this.preview = '';
    this.progress = 0;
    this.selectedFiles = event.target.files;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);

      if (file) {
        this.preview = '';
        this.currentFile = file;

        // Preview part
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.preview = e.target.result;
        };
        reader.readAsDataURL(this.currentFile);

      }
    }
  }

  //
  upload(): void {
    this.progress = 0;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);

      if (file) {
        this.currentFile = file;

        this.uploadService.upload(this.currentFile).subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round((100 * event.loaded) / event.total);
            } else if (event instanceof HttpResponse) {
              this.message = event.body.message;
              this.imageInfos = this.uploadService.getFiles();
            }
          },
          error: (err: any) => {
            this.progress = 0;

            if (err.error && err.error.message) {
              this.message = err.error.message;
            } else {
              this.message = 'Could not upload the image!';
            }

            this.currentFile = undefined;
          },
        });
      }

      this.selectedFiles = undefined;
    }
  }

  public closeModal() {
    this.modalService.dismissAll();
  }

}
